var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.loaded
        ? _c("div", { staticClass: "contentBlock" }, [
            _c("div", { staticClass: "workSpaceWrapper" }, [
              _c("div", { staticClass: "workSpace" }, [
                _c("div", { staticClass: "loading" }, [
                  _vm._v(
                    "\n\t\t\t\t\t" + _vm._s(_vm.$t("loading")) + "\n\t\t\t\t\t"
                  ),
                  _c("br"),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "loadingBar" }),
                ]),
              ]),
            ]),
          ])
        : !_vm.isConnected || !_vm.hasRequiredScopes
        ? _c("div", { staticClass: "contentBlock" }, [
            _c("div", { staticClass: "notConnectedWrapper" }, [
              _c("div", { staticClass: "workSpace" }, [
                _c("div", { staticClass: "viewHeader" }, [
                  _c("span", { staticClass: "header" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t("buttonConnectWith", {
                            name: _vm.channelModelName,
                          })
                        ) +
                        "\n\t\t\t\t\t"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                !_vm.isConnected
                  ? _c("div", { staticClass: "notConnected" }, [
                      _c("div", { staticClass: "notConnectedText" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.channelModel.folders
                                ? _vm.$t(
                                    "networkPermissionsFoldersDescription",
                                    { network: _vm.channelModelName }
                                  )
                                : _vm.$t(
                                    "networkPermissionsPhotosDescription",
                                    { network: _vm.channelModelName }
                                  )
                            ) +
                            "\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buttonWrapper" },
                        [
                          _vm.source == "facebook"
                            ? _c(
                                "FacebookButtonView",
                                { on: { buttonClicked: _vm.connect } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t("buttonConnectWith", {
                                          name: _vm.channelModelName,
                                        })
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              )
                            : _vm.source == "gplus"
                            ? _c(
                                "GoogleButtonView",
                                { on: { buttonClicked: _vm.connect } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t("buttonConnectWith", {
                                          name: _vm.channelModelName,
                                        })
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              )
                            : _vm.source == "instagram"
                            ? _c(
                                "InstagramButtonView",
                                { on: { buttonClicked: _vm.connect } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t("buttonConnectWith", {
                                          name: _vm.channelModelName,
                                        })
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              )
                            : _vm.source == "microsoft"
                            ? _c(
                                "MicrosoftButtonView",
                                { on: { buttonClicked: _vm.connect } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t("buttonConnectWith", {
                                          name: _vm.channelModelName,
                                        })
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              )
                            : _c(
                                "button",
                                {
                                  staticClass: "toolbutton",
                                  on: { click: _vm.connect },
                                },
                                [
                                  _c("i", { class: ["icon", _vm.connectIcon] }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t("buttonConnectWith", {
                                            name: _vm.channelModelName,
                                          })
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    ),
                                  ]),
                                ]
                              ),
                        ],
                        1
                      ),
                    ])
                  : _c("div", { staticClass: "missingPermissions" }, [
                      _c("div", { staticClass: "avatar" }, [
                        _vm.profilePicture
                          ? _c("img", { attrs: { src: _vm.profilePicture } })
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "permissionText" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("greeting")) +
                            " " +
                            _vm._s(_vm.profileName) +
                            ",\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t("connectedToOauthNetwork", {
                                networkName: _vm.channelModelName,
                              })
                            ) +
                            "\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t("askOauthPermission", {
                                networkName: _vm.channelModelName,
                              })
                            ) +
                            "\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "toolbutton",
                            on: { click: _vm.connect },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("buttonAddPermission")) +
                                "\n\t\t\t\t\t\t"
                            ),
                          ]
                        ),
                      ]),
                    ]),
              ]),
            ]),
          ])
        : _vm.channelModel.albums
        ? _c("CloudAlbumSelectorView", {
            staticClass: "cloudAlbumSelector",
            attrs: {
              "channel-model": _vm.channelModel,
              "import-mode": _vm.importMode,
            },
            on: { selectPhoto: _vm.selectPhoto },
          })
        : _vm.channelModel.folders || _vm.channelModel.photos
        ? _c("CloudPhotoSelectorView", {
            staticClass: "cloudPhotoSelector",
            attrs: {
              "channel-model": _vm.channelModel,
              "import-mode": _vm.importMode,
              "toolbar-mode": _vm.toolbarMode,
            },
            on: {
              selectPhoto: _vm.selectPhoto,
              importPhotos: function ($event) {
                return _vm.$emit("importPhotos")
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }